const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  }
  const domain =
    location.hostname == 'localhost'
      ? ''
      : ';domain=.' + location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
  const security = location.hostname == 'localhost' ? '' : ';SameSite=None; Secure';
  document.cookie = name + '=' + value + expires + ';path=/' + domain + security;
};

const readCookie = (name) => {
  let nameEQ = encodeURI(name) + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return decodeURI(c.substring(nameEQ.length, c.length));
  }
  return null;
};

const getQueryString = (name, url) => {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

// --- Whitepapers gating logic ---
const registeredQuery = getQueryString('registered') === 'true';
const registeredCookie = readCookie('registered') === 'true';
if (registeredQuery || registeredCookie) {
  setCookie('registered', 'true', 30);
  const gate = document.querySelector('.gate.locked');
  if (gate) {
    gate.classList.remove('locked');
  }
}

// --- Catalog gating logic ---
const downloadQuery = getQueryString('download') === 'true';
const downloadCookie = readCookie('tpc-form-download') === 'true';
if (downloadQuery || downloadCookie) {
  setCookie('tpc-form-download', 'true', 30);
  const formDownload = document.getElementById('form-download-catalog');
  const formSuccess = document.getElementById('form-success');
  if (formDownload) formDownload.classList.add('d-none');
  if (formSuccess) formSuccess.classList.remove('d-none');
}

// Scroll-follow for .disabled-message inside .gate.locked (whitepapers only)
window.addEventListener('DOMContentLoaded', function () {
  const gate = document.querySelector('.gate.locked');
  const disabledMsg = document.querySelector('.disabled-message');
  if (gate && disabledMsg) {
    // Ensure gate is position: relative for absolute positioning
    gate.style.position = gate.style.position || 'relative';

    const offsetStart = 150; // Start animation 200px after gate top

    const updateDisabledMsgPosition = () => {
      const gateRect = gate.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;
      const gateTop = gateRect.top + scrollY;
      const gateHeight = gate.offsetHeight;
      const msgHeight = disabledMsg.offsetHeight;
      // Stop 300px before the end of .gate.locked
      const maxTop = gateTop + gateHeight - 50 - msgHeight / 2;

      let targetTop = scrollY + window.innerHeight / 2 - msgHeight / 2;

      // Animation starts 200px after gate top
      if (targetTop < gateTop + offsetStart) targetTop = gateTop + offsetStart;
      if (targetTop > maxTop) targetTop = maxTop;

      disabledMsg.style.position = 'absolute';
      disabledMsg.style.top = targetTop - gateTop + 'px';
    };

    window.addEventListener('scroll', updateDisabledMsgPosition);
    window.addEventListener('resize', updateDisabledMsgPosition);
    updateDisabledMsgPosition();
  }
});
